
// Stake-type group ids
export const VICTORY_GROUP = 1;               // Победа
export const HANDICAP_GROUP = 2;              // Фора
export const TOTAL_GROUP = 3;                 // Тотал
export const CORNER_KICKS_TOTAL_GROUP = 4;    // Тотал угловых
export const CORNER_KICKS_HANDICAP_GROUP = 5; // Фора угловых
export const RED_CARD_PRESENCE_GROUP = 6;     // Будет красная карточка
export const YELLOW_CARDS_TOTAL_GROUP = 7;    // Тотал ЖК(желтых карточек)
export const YELLOW_CARD_PRESENCE_GROUP = 8;  // Будет желтая карточка
export const RED_CARDS_TOTAL_GROUP = 9;       // Будет желтая карточка
export const ASIAN_HANDICAP_GROUP = 10;       // Фора Азия
export const TIE_BREAK_GROUP = 100;           // Тайбрейк
export const SETS_TOTAL_GROUP = 101;          // Тотал по сетам
export const MORE_BREAKS_GROUP = 102;         // Больше брейков
export const EVEN_ODD_GROUP = 103;            // Чет/Нечет

// Grid line ids
// soccer
export const SOCCER_MAIN_LINE_ID          = 1;  // Главная линия
export const SOCCER_FIRST_HALF_LINE_ID    = 4;  // Первый тайм
export const SOCCER_SECOND_HALF_LINE_ID   = 21; // Второй тайм
export const SOCCER_CORNER_KICKS_LINE_ID  = 3;  // Угловые
export const SOCCER_YELLOW_CARD_LINE_ID   = 5;  // ЖК (желтые карточки)
// tennis
export const TENNIS_MAIN_LINE_ID          = 20;  // Главная линия
export const TENNIS_FIRST_SET_LINE_ID     = 21;  // Первый сет
export const TENNIS_SECOND_SET_LINE_ID    = 22;  // Второй сет
export const TENNIS_THIRD_SET_LINE_ID     = 23;  // Третий сет
export const TENNIS_FOURTH_SET_LINE_ID    = 24;  // Четвертый сет
export const TENNIS_FIFTH_SET_LINE_ID     = 25;  // Пятый сет
export const TENNIS_TIE_BREAK_LINE_ID     = 26;  // Тайбрейк
export const TENNIS_ACE_LINE_ID           = 27;  // Эйс
// basketball
export const BASKETBALL_MAIN_LINE_ID                        = 30;  // Главная линия
export const BASKETBALL_FIRST_QUARTER_LINE_ID               = 31;  // Первая четверть
export const BASKETBALL_SECOND_QUARTER_LINE_ID              = 32;  // Вторая четверть
export const BASKETBALL_FIRST_HALF_LINE_ID                  = 35;  // Первая половина
export const BASKETBALL_SECOND_HALF_LINE_ID                 = 36;  // Вторая половина
export const BASKETBALL_FIRST_QUARTER_THREE_POINTS_LINE_ID  = 36;  // Вторая половина
// volleyball
export const VOLLEYBALL_MAIN_LINE_ID                        = 40;  // Главная линия
export const VOLLEYBALL_FIRST_SET_LINE_ID                   = 41;  // Первый сет
export const VOLLEYBALL_SECOND_SET_LINE_ID                  = 42;  // Второй сет
export const VOLLEYBALL_ACE_LINE_ID                         = 43;  // Эйс
// ice hockey
export const ICE_HOCKEY_MAIN_LINE_ID                        = 8000;  // Главная линия
export const ICE_HOCKEY_FIRST_PERIOD_LINE_ID                = 8001;  // Первый перид
export const ICE_HOCKEY_SECOND_PERIOD_LINE_ID               = 8002;  // Второй период
